import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FilterBcDTO } from '../shared/dtos/filterBcDTO';
import { FilterBpDTO } from '../shared/dtos/filterBpDTO';

@Injectable({
  providedIn: 'root'
})
export class FiltreService {

  private filtreSource = new BehaviorSubject<FilterBcDTO>(new FilterBcDTO());
  private filtreSourceBp = new BehaviorSubject<FilterBpDTO>(new FilterBpDTO());
  public filtre = this.filtreSource.asObservable();
  public filtreBp = this.filtreSourceBp.asObservable();
  constructor() {
    const localFlBc = localStorage.getItem('flBc');
    if (localFlBc) {
      this.filtreSource.next(JSON.parse(localFlBc));
    }
    const localFlBp = localStorage.getItem('flBp');
    if (localFlBp) {
      this.filtreSourceBp.next(JSON.parse(localFlBp));
    }
  }

  changeFiltre(fl: FilterBcDTO): void {
    this.filtreSource.next(fl);
    localStorage.setItem('flBc', JSON.stringify(fl));
  }

  changeFiltreBP(fl: FilterBpDTO): void {
    this.filtreSourceBp.next(fl);
    localStorage.setItem('flBp', JSON.stringify(fl));
  }
}
